import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { styled, InputBase, FormControl, FormLabel, Box, IconButton, Tooltip } from "@mui/material";
import { PALETTE } from "../Theme/Palette";
import { Formik } from "formik";
import moment from "jalali-moment";

const DesignedInput = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    "&::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
    },
    "&::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
    },
    "&[type=number]": {
      MozAppearance: "textfield",
    },
    position: "relative",
    color: PALETTE.third,
    backgroundColor: PALETTE.primary,
    textAlign: "right",
    borderStyle: "none",
    borderRadius: "0.5rem",
    fontSize: 14,
    fontWeight: "bold",
    padding: "0.6rem 0.7rem",
    overflow: "hidden",
    textOverflow: "ellipsis !important",
    "&:disabled , &.Mui-disabled": {
      WebkitTextFillColor: PALETTE.sixth,
      color: PALETTE.sixth,
      backgroundColor: PALETTE.fifth,
    },
  },
}));

//todo: qsmt error byd handle beshe
function Input({
  placeholder,
  name,
  id,
  label,
  type = "text",
  value,
  error = false,
  disabled,
  flex,
  labelFlex,
  validationType = "",
  onChange = () => {},
  onClick = () => {},
  onFocus = () => {},
  onErrorMessage = () => {},
  containerStyle,
}) {
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [showError, setShowError] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const inputRef = React.useRef(null);
  const [showSubmitError, setShowSubmitError] = useState(
    (!value || value === undefined || value === "") && error
  );
  const YEAR = moment().format("jYYYY/jMM/jDD").split("/")[0];

  const handleType = () => {
    if (type === "password") {
      return passwordVisibility ? "text" : "password";
    }
  };

  const checkNationalCode = (code) => {
    code = [...code].reverse().join("");
    let sum = 0;
    let all_the_same = true;
    code
      .split("")
      .slice(1)
      .forEach((number, i) => {
        if (parseInt(number) !== parseInt(code[0])) {
          all_the_same = false;
        }
        sum += number * (i + 2);
      });
    if (sum % 11 < 2) {
      return parseInt(code[0]) === sum % 11 && !all_the_same;
    } else {
      return parseInt(code[0]) === 11 - (sum % 11) && !all_the_same;
    }
  };

  useEffect(() => {
    if (value === "") {
      setShowError(false);
    }

    if (inputRef.current) {
      const element = inputRef.current;
      setIsTruncated(element.scrollWidth > element.offsetWidth - 3);
    }
  }, [value, showError]);

  useEffect(() => {
    setShowSubmitError(error);
  }, [error, value]);

  return (
    <Formik
      initialValues={{ [id]: value }}
      validate={() => {
        const errors = {};
        if (value !== "" && value !== undefined) {
          if (type === "number") {
            if (validationType === "nationalCode") {
              if (/^\d{10}$/.test(value) && checkNationalCode(value)) {
                errors[id] = "";
                onErrorMessage({ [id]: "" });
              } else {
                errors[id] = "کد ملی اشتباه است.";
                onErrorMessage({ [id]: "کد ملی اشتباه است." });
              }
            } else if (validationType === "year") {
              if (!/^\d{4}$/.test(value) || parseInt(YEAR) < parseInt(value)) {
                errors[id] = "سال اشتباه است.";
                onErrorMessage({ [id]: "سال اشتباه است." });
              } else {
                errors[id] = "";
                onErrorMessage({ [id]: "" });
              }
            }
            if (validationType === "phoneNumber") {
              if (!/^09\d{9}$/.test(value)) {
                errors[id] = "شماره موبایل اشتباه است.";
                onErrorMessage({ [id]: "شماره موبایل اشتباه است" });
              } else {
                errors[id] = "";
                onErrorMessage({ [id]: "" });
              }
            }
          }
          if (type === "text") {
            if (validationType === "email") {
              if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
                errors[id] = "آدرس ایمیل اشتباه است.";
                onErrorMessage({ [id]: ".آدرس ایمیل اشتباه است" });
              } else {
                errors[id] = "";
                onErrorMessage({ [id]: "" });
              }
            }
          }
        } else {
          errors[id] = "";
          onErrorMessage({ [id]: "" });
        }
        return errors;
      }}
    >
      {({ errors, handleBlur }) => (
        <FormControl
          disabled={disabled}
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            minWidth: "100%",
            maxWidth: "100%",
          }}
        >
          {label && (
            <FormLabel
              htmlFor={id}
              sx={{
                flex: labelFlex,
                textAlign: "right",
                color: "#4C466F !important",
                fontSize: "14px",
              }}
            >
              {label}
            </FormLabel>
          )}
          <Box sx={{ flex }} position="relative" onClick={onClick} onFocus={onFocus}>
            <Tooltip title={isTruncated ? value : ""} arrow>
              <DesignedInput
                name={name}
                id={id}
                type={handleType()}
                placeholder={placeholder}
                value={value}
                onChange={(event) => {
                  if (type === "number") {
                    if (/^\d+$/.test(event.target.value) || event.target.value.length === 0) {
                      onChange(event);
                    } else {
                      event.target.value = "";
                    }
                  } else {
                    onChange(event);
                  }
                }}
                inputRef={inputRef}
                sx={{
                  flex: 1,
                  width: "100%",
                  direction: type === "password" ? "ltr" : "rtl",
                  borderRadius: "0.5rem",
                  border: disabled
                    ? "1px solid transparent"
                    : (errors[id]?.length > 0 && showError) || showSubmitError
                    ? "1px solid #FF0000"
                    : "1px solid " + PALETTE.fourth,
                }}
                inputProps={{
                  style: {
                    cursor: isTruncated ? "pointer" : "",
                  },
                }}
                onBlur={async (event) => {
                  if (value !== "") await setShowError(true);
                  await handleBlur(event);
                }}
              />
            </Tooltip>
            {type === "password" && (
              <IconButton
                onClick={setPasswordVisibility.bind(this, (prev) => !prev)}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "0",
                  transform: "translate(0,-50%)",
                }}
              >
                {passwordVisibility ? (
                  <AiFillEyeInvisible fontSize="1.1rem" />
                ) : (
                  <AiFillEye fontSize="1.1rem" />
                )}
              </IconButton>
            )}
            <Box
              width="100%"
              sx={{ direction: "rtl", color: "#FF0000", fontSize: "0.7rem", fontWeight: "500" }}
            >
              {showError && errors[id]}
              {errors.yearRange ? errors.yearRange : ""}
            </Box>
          </Box>
        </FormControl>
      )}
    </Formik>
  );
}

Input.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.oneOfType([PropTypes.string]),
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element]),
  type: PropTypes.oneOf(["text", "password", "number", "tel"]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
};

export default Input;
